import {
    getValidationSchemaOfEffect,
    getOptionsDefaultsOfEffect,
    getOptionsMappingsOfEffect,
    getPresetNameOfEffect
} from './effectSchemaAPI';
import includes from 'lodash/includes';
import keys from 'lodash/keys';
import isEmpty from 'lodash/isEmpty';
import difference from 'lodash/difference';
import set from 'lodash/set';
import clone from 'lodash/clone';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import {validateByType, isValueInRange, TYPES} from '../validation';
import reporter from '../../reporter';
import {generateError} from '../errors';

function validateAndReportDeprecatedEffect(effectName, options, functionName, compNickname) {
    if (!isEmpty(options)) {
        reporter.reportSdkWarning(generateError.warning_deprecated_effect_with_options({
            functionName,
            compNickname,
            effectName
        }));
        return false;
    }
    // TODO Uncomment when new docs are released
    // reporter.reportSdkWarning(generateError.warning_deprecated_effect_name({
    //     functionName,
    //     compNickname,
    //     effectName
    // }));
    return true;
}

function reportInvalidOptionsValue(value, key, functionName, compNickname, effectName) {
    reporter.reportSdkWarning(generateError.warning_invalid_effect_options({
        functionName,
        compNickname,
        effectName,
        wrongProperty: 'value',
        wrongValue: JSON.stringify({[key]: value})
    }));
}

function validateOptionKeysAndReportIfNecessary(effectName, optionKeys, validKeys, functionName, compNickname) {
    const invalidKeys = difference(optionKeys, validKeys);

    if (!isEmpty(invalidKeys)) {
        reporter.reportSdkWarning(generateError.warning_invalid_effect_options({
            functionName,
            compNickname,
            effectName,
            wrongProperty: 'keys',
            wrongValue: invalidKeys
        }));
        return false;
    }
    return true;
}

function validateOptionValuesAndReportIfNecessary(effectName, options, validations, functionName, compNickname) {
    let res = true;
    forEach(options, (v, k) => {
        const effectValidations = validations[k];
        if (!validateByType(v, effectValidations.type)) {
            reportInvalidOptionsValue(v, k, functionName, compNickname, effectName);
            res = false;
            return;
        }

        if (effectValidations.enum && !includes(effectValidations.enum, v)) {
            reportInvalidOptionsValue(v, k, functionName, compNickname, effectName);
            res = false;
            return;
        }

        if (effectValidations.range && !isValueInRange(v, effectValidations.range.minValue, effectValidations.range.maxValue)) {
            reportInvalidOptionsValue(v, k, functionName, compNickname, effectName);
            res = false;
        }
    });
    return res;
}

function validateEffect(effect, options, functionName, compNickname, deprecatedValues) {
    if (!effect) {
        if (!isEmpty(options)) {
            reporter.reportSdkWarning(generateError.warning_effect_options_not_set({
                functionName,
                compNickname
            }));
            return false;
        }
        return true;
    }

    if (includes(deprecatedValues, effect)) {
        return validateAndReportDeprecatedEffect(effect, options, functionName, compNickname);
    }

    const validationSchema = getValidationSchemaOfEffect(effect);
    if (!validationSchema) {
        reporter.reportSdkWarning(generateError.warning_invalid_effect_name({
            functionName,
            compNickname,
            effectName: effect
        }));

        return false;
    }

    if (!isNil(options) && !validateByType(options, TYPES.OBJECT)) {
        reporter.reportSdkWarning(generateError.warning_invalid_type_effect_options({
            functionName,
            compNickname,
            effectName: effect,
            wrongValue: options
        }));
        return false;
    }

    const validKeys = keys(validationSchema);
    const optionKeys = keys(options);
    const allOptionKeysValid = validateOptionKeysAndReportIfNecessary(effect, optionKeys, validKeys, functionName, compNickname);
    if (!allOptionKeysValid) {
        return false;
    }

    return validateOptionValuesAndReportIfNecessary(effect, options, validationSchema, functionName, compNickname);
}

function buildEffectParams(options, optionsDefaults, optionsMappings) {
    const params = clone(optionsDefaults);
    forEach(options, (v, k) => {
        const path = get(optionsMappings, `keys.${k}`) || k;

        let value = v;
        value = get(optionsMappings, `values.${k}.convertMsToSecs`) ? v / 1000 : value;
        value = get(optionsMappings, `values.${k}.${v}`, value);

        set(params, path, value);
    });
    return params;
}

function buildEffectObject(effect, options, functionData) {
    const {deprecatedValues, suffix, noSuffixPresets} = functionData;
    if (includes(deprecatedValues, effect)) {
        return {presetName: effect, params: {}};
    }

    const presetName = getPresetNameOfEffect(effect, suffix, noSuffixPresets);
    const optionsDefaults = getOptionsDefaultsOfEffect(effect);
    const params = buildEffectParams(options, optionsDefaults, getOptionsMappingsOfEffect(effect));

    return {
        presetName,
        params
    };
}

export default {
    validateEffect,
    buildEffectObject
};


// WEBPACK FOOTER //
// ./js/modules/privates/validations/animations/effectValidation.es6